// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__TLHRH","productName":"Table_productName__3wTAZ"};